import { markers, selectData } from "../dummyData";

export async function getMapFilters() {
    // if in production, fetch data from API
    // else, fetch data using `getMockMapFilters`
    if (process.env.NODE_ENV === "production") {
        // fetch data from API
        // return await fetchMapFilters();
    }
    // fetch data using `getMockMapFilters`
    return await getMockMapFilters();
}

export async function getMapMarkers() {
    // if in production, fetch data from API
    // else, fetch data using `getMockMapMarkers`
    if (process.env.NODE_ENV === "production") {
        // fetch data from API
        // return await fetchMapMarkers();
    }
    // fetch data using `getMockMapMarkers`
    return await getMockMapMarkers();
}

async function getMockMapFilters() {
    // await 2000; then return mock data `selectData`
    await new Promise(resolve => setTimeout(resolve, selectData))
    return selectData;
}

async function getMockMapMarkers() {
    // await 2000; then return mock data `selectData`
    await new Promise(resolve => setTimeout(resolve, selectData))
    return markers;
}

async function fetchMapFilters() {
    // fetch data from API
    // return await fetch("api-url");
}

async function fetchMapMarkers() {
    // fetch data from API
    // return await fetch("api-url");
}